import { render } from "./VideoPage.vue?vue&type=template&id=76adb84d"
import script from "./VideoPage.vue?vue&type=script&lang=js"
export * from "./VideoPage.vue?vue&type=script&lang=js"

import "./VideoPage.vue?vue&type=style&index=0&id=76adb84d&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__